<template>
  <div>
    <zee-receivables-filters></zee-receivables-filters>
    <el-row>
      <zee-receivables-list></zee-receivables-list>
    </el-row>
  </div>
</template>
<script>
import * as types from '@/store/mutation-types';
import { mapGetters } from 'vuex';
import zeeReceivablesFilters from './partials/receivables-filters/ReceivablesFilters.vue';
import zeeReceivablesList from './partials/ReceivablesList.vue';

export default {
  components: {
    zeeReceivablesFilters,
    zeeReceivablesList,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      isReceivablesFirstLoad: 'isReceivablesFirstLoad',
    }),
  },
  beforeMount() {
    document.querySelector('body').className = 'is-receivable';
  },
  created() {
    if (this.isReceivablesFirstLoad) {
      this.$store.dispatch('getSearchedReceivableTransactionsData');
      this.$store.commit(types.SET_IS_RECEIVABLES_FIRST_LOAD, false);
    }
  },
};
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 10px;
  &:last-child {
      margin-bottom: 0;
  }
}
.el-notification .el-icon-warning {
    color: #E74C3C;
}
</style>




// WEBPACK FOOTER //
// src/components/receivables/Receivables.vue